export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const isLocalhost = ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
    if (isLocalhost) {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
        .then(() => {
          if (!("caches" in window)) return null;
          return caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
        })
        .catch(() => {});
      return;
    }

    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
